import { useState } from "react"
import { ReactComponent as SearchSvg } from "../style/images/btn_search.svg"

export const SearchBox = ({placeholder, onClick}) => {
  const [val ,setVal] = useState('')
  return (
    <div className="search">
      <input type='text' placeholder={placeholder} value={val} onChange={(evt)=>{setVal(evt.target.value)}} />
      <SearchSvg className='search_icon' style={{width:'0.9vw'}} onClick={()=>{onClick(val); setVal('');}} />
    </div>
  )
}

export const SelectionBox = ({placeholder, options, handleSelect, val, loading=false}) => {
  if (loading) return (<select><option selected disabled>{placeholder}</option></select>)
  else return (
    <select onChange={handleSelect} value={val[0]===undefined? placeholder:val}>
      <option disabled>{placeholder}</option>
      {options.map((e)=>(<option value={e}>{e}</option>))}
    </select>
  )
}